/**
 * Vehicle names as people write them. The catalogue stores makes and models
 * in capitals ("TOYOTA COROLLA"), which the Aperio preset printed as they
 * were (QA 2026-09-25 #49). Display only: the stored value, which the
 * catalogue queries and the booking use, never changes.
 */

/** Short capitalised words that are names in their own right. */
const KEEP_UPPER = new Set(['BMW', 'GMC', 'MG', 'AMG', 'SRT', 'GT', 'GTI', 'SUV']);
/** Short words that read as words ("Kia", not "KIA"). */
const WORDS = new Set(['KIA', 'RAM', 'VW']);

function caseWord(word: string): string {
  if (!word) return word;
  const upper = word.toUpperCase();
  if (word !== upper) return word; // already mixed case: someone chose it
  if (KEEP_UPPER.has(upper)) return upper;
  if (WORDS.has(upper)) return upper === 'VW' ? 'VW' : upper[0] + upper.slice(1).toLowerCase();
  // Model codes keep their capitals: RAV4, CR-V, F-150, 2ZR-FAE.
  if (/\d/.test(word) || word.length <= 2) return upper;
  return upper[0] + upper.slice(1).toLowerCase();
}

/** "TOYOTA COROLLA" -> "Toyota Corolla", "CR-V" and "RAV4" unchanged. */
export function vehicleNameCase(text?: string | null): string {
  return String(text ?? '')
    .split(/(\s+)/)
    .map((part) => (/^\s+$/.test(part)
      ? part
      : part.split('-').map(caseWord).join('-')))
    .join('');
}

/** "2020 Toyota Corolla", without stray spaces when a part is missing. */
export function vehicleLabel(
  year?: string | number | null,
  make?: string | null,
  model?: string | null,
): string {
  return [year, vehicleNameCase(make), vehicleNameCase(model)]
    .map((part) => String(part ?? '').trim())
    .filter(Boolean)
    .join(' ');
}
